// import React, { useEffect, useState, useMemo, useRef } from "react";
// import axios from "axios";
// import { motion, AnimatePresence } from "framer-motion";
// import confetti from "canvas-confetti";
// import { apiurl } from "../config/config";
// import { Chart, registerables } from "chart.js";
// // import ChartDataLabels from "chartjs-plugin-datalabels"; // ✅ top-level

// // 🔊 Sounds
// import crowdSoundFile from "../audio/winner.mp3";
// import winSoundFile from "../audio/winner.mp3";

// // Your other component imports here

// // Chart.register(...registerables);
// // Chart.register(ChartDataLabels);

// // // 🔊 Sounds
// // import crowdSoundFile from "../audio/winner.mp3";
// // import winSoundFile from "../audio/winner.mp3";

// /* ================= CONFIG ================= */

// const FLOOR_HEADS = [
//   { key: "GMIT", name: "Rahul Bhusan", target: 1100, photo: "/managers/rahulbhusan.jpeg" },
//   { key: "ALTF", name: "Anand Suman", target: 1800, photo: "/managers/anandsuman.png" },
// ];

// const FLOOR_MANAGERS = {
//   GMIT: ["JayVijay5099", "LavitBhati714"],
//   ALTF: ["SanjayRewani1619", "ASHWANI3434", "Himanshu1203", "Abhishek4629"],
// };

// const MANAGER_META = {
//   SanjayRewani1619: { name: "Sanjay", target: 600, photo: "/managers/sanjayrewani.jpeg" },
//   Abhishek4629: { name: "Abhishek", target: 600, photo: "/managers/abhishek.jpeg" },
//   Himanshu1203: { name: "Himanshu", target: 300, photo: "/managers/himanshu.png" },
//   ASHWANI3434: { name: "Ashwani", target: 300, photo: "/managers/ashwani.png" },
// };

// const SLIDES = [
//   { type: "INTRO" },
//   { type: "FLOOR" },
//   { type: "MANAGER", A: "Abhishek4629", B: "SanjayRewani1619" },
//   { type: "MANAGER", A: "Himanshu1203", B: "ASHWANI3434" },
// ];

// /* ================= UTILS ================= */

// const winnerOf = (a, b) => (a === b ? "DRAW" : a > b ? "A" : "B");

// const getProgressMeta = (p) => {
//   if (p >= 100) return { color: "#16a34a", text: "TARGET ACHIEVED" };
//   if (p >= 90) return { color: "#22c55e", text: "EXCELLENT" };
//   if (p >= 80) return { color: "#4ade80", text: "VERY GOOD" };
//   if (p >= 70) return { color: "#a3e635", text: "ON TRACK" };
//   if (p >= 60) return { color: "#facc15", text: "NEEDS PUSH" };
//   if (p >= 50) return { color: "#fbbf24", text: "NEEDS PUSH" };
//   if (p >= 40) return { color: "#fb923c", text: "CRITICAL PUSH" };
//   if (p >= 30) return { color: "#f97316", text: "CRITICAL PUSH" };
//   if (p >= 20) return { color: "#ef4444", text: "ALERT" };
//   return { color: "#dc2626", text: "HIGH ALERT" };
// };

// const getBattleCommentary = (A, B, aVal, bVal) => {
//   if (aVal === bVal) return { headline: "It's a Perfect Draw 🤝", sub: "Anyone can take the lead with 1 order!" };
//   const leaderId = aVal > bVal ? A : B;
//   const trailerId = aVal > bVal ? B : A;
//   const diff = Math.abs(aVal - bVal);
//   return { headline: `${MANAGER_META[leaderId].name} is leading by +${diff} orders`, sub: `${MANAGER_META[trailerId].name} needs ${diff + 1} more orders to WIN 🏆` };
// };

// const getColor = (p) => {
//   if (p >= 100) return "#16a34a";
//   if (p >= 90) return "#22c55e";
//   if (p >= 80) return "#4ade80";
//   if (p >= 70) return "#a3e635";
//   if (p >= 60) return "#facc15";
//   if (p >= 50) return "#fbbf24";
//   if (p >= 40) return "#fb923c";
//   if (p >= 30) return "#f97316";
//   if (p >= 20) return "#ef4444";
//   return "#dc2626";
// };

// /* ================= SCALE HOOK ================= */

// function useTVScale() {
//   const [scale, setScale] = useState(1);
//   useEffect(() => {
//     const updateScale = () => setScale(window.innerWidth / 1920);
//     updateScale();
//     window.addEventListener("resize", updateScale);
//     return () => window.removeEventListener("resize", updateScale);
//   }, []);
//   return scale;
// }

// /* ================= MAIN COMPONENT ================= */

// export default function AdvancedScreen() {
//   const scale = useTVScale();
//   const [managerOrders, setManagerOrders] = useState({});
//   const [slide, setSlide] = useState(0);
//   const [lastWinner, setLastWinner] = useState(null);

//   const crowdAudio = useRef(null);
//   const winAudio = useRef(null);

//   /* ---------- FETCH ORDERS ---------- */
//   useEffect(() => {
//     const fetchData = async () => {
//       const res = await axios.get(`${apiurl}/utils/crm/realTimeOrderData`, {
//         headers: { token: "ad2355a9d54335e27e2c3a3ed5b6e381" },
//         params: { from_date: "2026-01-27", to_date: "2026-01-27" },
//       });
//       const list = res?.data?.data?.result?.data?.managers || [];
//       const map = {};
//       list.forEach((m) => (map[m.o_manager_name] = Number(m.totalOrders || 0)));
//       setManagerOrders(map);
//     };
//     fetchData();
//     const api = setInterval(fetchData, 30000);
//     return () => clearInterval(api);
//   }, []);

//   /* ---------- AUTO SLIDE ---------- */
//   const current = SLIDES[slide];
//   useEffect(() => {
//     const duration = current.type === "INTRO" ? 10000 : 40000;
//     const timer = setTimeout(() => setSlide((s) => (s + 1) % SLIDES.length), duration);
//     return () => clearTimeout(timer);
//   }, [current]);

//   /* ---------- FLOOR DATA ---------- */
//   const floorData = useMemo(() => {
//     const sum = (arr) => arr.reduce((a, b) => a + (managerOrders[b] || 0), 0);
//     return { GMIT: sum(FLOOR_MANAGERS.GMIT), ALTF: sum(FLOOR_MANAGERS.ALTF) };
//   }, [managerOrders]);

//   /* ---------- MANAGER BATTLE ---------- */
//   const managerBattle = useMemo(() => {
//     if (current.type !== "MANAGER") return null;
//     const aVal = managerOrders[current.A] || 0;
//     const bVal = managerOrders[current.B] || 0;
//     return { aVal, bVal, win: winnerOf(aVal, bVal), diff: Math.abs(aVal - bVal) };
//   }, [current, managerOrders]);

//   /* ---------- CONFETTI + SOUND ---------- */
//   useEffect(() => {
//     if (managerBattle?.win && managerBattle.win !== "DRAW") {
//       confetti({ particleCount: 120, spread: 120 });
//       setLastWinner(managerBattle.win);
//       if (crowdAudio.current) crowdAudio.current.play();
//       if (winAudio.current) winAudio.current.play();
//     }
//   }, [managerBattle]);

//   /* ================= RENDER ================= */
//   return (
//     <div
//       style={{ transform: `scale(${scale})`, transformOrigin: "top left", width: 1920, height: 1080 }}
//       className="bg-gray-50 overflow-hidden"
//     >
//       <audio ref={crowdAudio} src={crowdSoundFile} preload="auto" />
//       <audio ref={winAudio} src={winSoundFile} preload="auto" />

//       {current.type === "INTRO" && <IntroSlide />}
//       {current.type === "FLOOR" && <FloorSlide floorData={floorData} />}
//       {current.type === "MANAGER" && <ManagerBattleSlide battle={managerBattle} A={current.A} B={current.B} />}
//     </div>
//   );
// }

// /* ================= INTRO SLIDE ================= */

// function IntroSlide() {
//   return (
//     <SlideWrapper>
//       <motion.h1 className="text-[80px] font-black text-center mb-14" animate={{ scale: [1, 1.05, 1] }} transition={{ repeat: Infinity, duration: 1.5 }}>
//         🔥 Today's Sales Battle 🔥
//       </motion.h1>

//       <div className="grid grid-cols-2 gap-20">
//         {Object.values(MANAGER_META).slice(0, 2).map((m, i) => {
//           const pct = Math.min(100, Math.round((0 / m.target) * 100)); // initial empty
//           return (
//             <motion.div key={m.name} initial={{ x: i === 0 ? -200 : 200, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ duration: 1 }} className="bg-white rounded-3xl p-12 shadow-2xl">
//               <img src={m.photo} className="w-72 h-72 mx-auto rounded-full" />
//               <h2 className="text-[52px] font-black text-center mt-6">{m.name}</h2>
//               <div className="h-6 bg-gray-200 rounded-full overflow-hidden mt-8">
//                 <motion.div initial={{ width: 0 }} animate={{ width: `${pct}%` }} transition={{ duration: 2 }} className="h-full rounded-full bg-green-500" />
//               </div>
//               <p className="text-center mt-4 text-[32px] font-bold">Target: {m.target}</p>
//             </motion.div>
//           );
//         })}
//       </div>
//     </SlideWrapper>
//   );
// }

// /* ================= FLOOR SLIDE ================= */

// function FloorSlide({ floorData }) {
//   const win = winnerOf(floorData.GMIT, floorData.ALTF);
//   return (
//     <SlideWrapper>
//       <h1 className="text-6xl font-black text-center mb-10">Live Floor Performance</h1>
//       <div className="grid grid-cols-2 gap-12">
//         {FLOOR_HEADS.map((f, i) => (
//           <AdvancedFloorCard key={f.key} floor={f} value={i === 0 ? floorData.GMIT : floorData.ALTF} achievement={Math.round((i === 0 ? floorData.GMIT : floorData.ALTF) / f.target * 100)} isWinner={win === (i === 0 ? "A" : "B")} isLoser={win === (i === 0 ? "B" : "A")} isDraw={win === "DRAW"} />
//         ))}
//       </div>
//     </SlideWrapper>
//   );
// }

// /* ================= MANAGER BATTLE SLIDE ================= */

// function ManagerBattleSlide({ battle, A, B }) {
//   const { aVal, bVal, win, diff } = battle;
//   const commentary = getBattleCommentary(A, B, aVal, bVal);
//   return (
//     <SlideWrapper>
//       <LiveCommentary headline={commentary.headline} sub={commentary.sub} />
//       <div className="grid grid-cols-2 items-center gap-5 mt-10">
//         <ManagerCard id={A} value={aVal} status={win === "A" ? "WIN" : win === "B" ? "LOSE" : "DRAW"} big />
//         <ManagerCard id={B} value={bVal} status={win === "B" ? "WIN" : win === "A" ? "LOSE" : "DRAW"} big />
//       </div>
//       <BattleChart A={A} B={B} aVal={aVal} bVal={bVal} />
//     </SlideWrapper>
//   );
// }

// /* ================= BATTLE CHART ================= */

// function BattleChart({ A, B, aVal, bVal }) {
//   const chartRef = useRef(null);

//   useEffect(() => {
//     const ctx = chartRef.current.getContext("2d");
//     const chart = new Chart(ctx, {
//       type: "bar",
//       data: {
//         labels: [MANAGER_META[A].name, MANAGER_META[B].name],
//         datasets: [{ data: [aVal, bVal], backgroundColor: ["#4ade80", "#f97316"], borderRadius: 20 }],
//       },
//       options: {
//         indexAxis: "y",
//         responsive: true,
//         plugins: { legend: { display: false }, datalabels: { color: "white", anchor: "end", align: "end", font: { size: 32, weight: "bold" } } },
//         scales: { x: { beginAtZero: true, ticks: { color: "#fff", font: { size: 24 } } }, y: { ticks: { color: "#fff", font: { size: 28 } } } },
//       },
//     });

//     return () => chart.destroy();
//   }, [A, B, aVal, bVal]);

//   return <canvas ref={chartRef} className="mt-10 w-full h-96 rounded-xl shadow-xl bg-gray-900" />;
// }

// /* ================= SLIDE WRAPPER ================= */

// const SlideWrapper = ({ children }) => (
//   <div className="min-h-screen flex items-center justify-center px-5 py-10">
//     <AnimatePresence mode="wait">
//       <motion.div key={Math.random()} initial={{ opacity: 0, x: 80 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -80 }} transition={{ duration: 0.6 }} className="w-full bg-gray-900 rounded-3xl shadow-2xl p-10 border-4 border-black text-white">
//         {children}
//       </motion.div>
//     </AnimatePresence>
//   </div>
// );

// const FloorCard = ({ data, value, status }) => {
//   const pct = Math.min(100, Math.round((value / data.target) * 100));
//   const color = getColor(pct);

//   return (
//     <motion.div
//       animate={status === "WIN" ? { scale: [1, 1.03, 1] } : {}}
//       transition={{ repeat: Infinity, duration: 1.5 }}
//       className={`relative p-8 rounded-3xl border-4 text-center ${
//         status === "WIN"
//           ? "shadow-[0_0_50px_rgba(34,197,94,0.5)]"
//           : status === "LOSE"
//             ? //   ? "opacity-80 grayscale"
//               " "
//             : ""
//       }`}
//       style={{ borderColor: color }}
//     >
//       <StatusStrip status={status} />

//       <div
//         className="mx-auto w-64 h-64 rounded-full p-2 mb-6"
//         style={{
//           background: `radial-gradient(circle, ${color} 0%, transparent 70%)`,
//         }}
//       >
//         <img
//           src={data.photo}
//           className="w-full h-full rounded-full border-4 mt-3"
//           style={{ borderColor: color }}
//         />
//       </div>

//       <h2 className="text-4xl font-black">{data.key}</h2>
//       <p className="text-xl">{data.name}</p>

//       <p className="text-6xl font-black mt-4" style={{ color }}>
//         {value}
//       </p>

//       <p className="text-lg text-gray-600 mb-3">
//         Target: <span className="font-bold">{data.target}</span>
//       </p>

//       <div className="h-5 bg-gray-200 rounded-full overflow-hidden">
//         <motion.div
//           initial={{ width: 0 }}
//           animate={{ width: `${pct}%` }}
//           transition={{ duration: 1 }}
//           className="h-full rounded-full"
//           style={{ backgroundColor: color }}
//         />
//       </div>

//       <p className="mt-2 text-xl font-bold" style={{ color }}>
//         {pct}% achieved
//       </p>
//     </motion.div>
//   );
// };

// const ManagerCard = ({ id, value, status }) => {
//   const m = MANAGER_META[id];
//   const pct = Math.min(100, Math.round((value / m.target) * 100));

//   const target = Number(m.target);
//   const remaining = Math.max(target - value, 0);

//   // const color = getColor(pct);

//   const { color, text } = getProgressMeta(pct);

//   return (
//     <motion.div
//       animate={status === "WIN" ? { scale: [1, 1.03, 1] } : {}}
//       transition={{ repeat: Infinity, duration: 1.4 }}
//       className={`relative p-8 rounded-3xl border-4 text-center overflow-hidden ${
//         status === "WIN"
//           ? "shadow-[0_0_40px_rgba(34,197,94,0.6)]"
//           : status === "LOSE"
//             ? //   ? "opacity-80 grayscale"
//               " "
//             : ""
//       }`}
//       // style={{ borderColor: color }}
//       style={{ borderColor: color }}
//     >
//       <StatusStrip status={status} />

//       {/* IMAGE */}
//       <div
//         className="mx-auto w-72 h-72 rounded-full p-2 mb-6"
//         style={{
//           background: `radial-gradient(circle, ${color} 0%, transparent 70%)`,
//         }}
//       >
//         <img
//           src={m.photo}
//           className="w-full h-full rounded-full border-4 mt-3"
//           style={{ borderColor: color }}
//         />
//       </div>

//       {/* NAME */}
//       <h2 className="text-3xl font-black">{m.name}</h2>

//       {/* VALUE */}
//       {/* <p className="text-6xl font-black my-3">
//         <span style={{ color }}>{value}</span>/
//         <span className="font-black">{m.target}</span>
//       </p> */}

//       <div className="text-[96px] font-extrabold leading-none">
//         <span style={{ color: color }}>{value}</span>
//         <span className="opacity-40 text-[56px]"> / {target}</span>
//       </div>

//       <p className="mt-4 text-[34px] font-semibold text-gray-700">
//         {remaining > 0
//           ? `${remaining} orders to target`
//           : "Target completed 🎉"}
//       </p>

//       {/* PROGRESS BAR */}
//       <div className="h-5 bg-gray-200 rounded-full overflow-hidden">
//         <motion.div
//           initial={{ width: 0 }}
//           animate={{ width: `${pct}%` }}
//           transition={{ duration: 1 }}
//           className="h-full rounded-full"
//           style={{ backgroundColor: color }}
//         />
//       </div>

//       <div className="mt-4 flex justify-between items-center">
//         <p className="text-[36px] font-extrabold" style={{ color }}>
//           {pct}% achieved
//         </p>

//         <p className="text-[40px] font-black tracking-wider" style={{ color }}>
//           {text}
//         </p>
//       </div>
//     </motion.div>
//   );
// };

// const StatusStrip = ({ status }) => (
//   <div
//     className={`absolute top-0 left-0 right-0 py-2 text-white font-bold text-xl rounded-t-3xl ${
//       status === "WIN"
//         ? "bg-green-600"
//         : status === "LOSE"
//           ? "bg-red-600"
//           : "bg-gray-600"
//     }`}
//   >
//     {status === "WIN"
//       ? "🏆 WINNER"
//       : status === "LOSE"
//         ? "😞 LOSER"
//         : "🤝 DRAW"}
//   </div>
// );

// function LiveLeadBanner({ text, winner }) {
//   return (
//     <motion.div
//       initial={{ y: -30, opacity: 0 }}
//       animate={{ y: 0, opacity: 1 }}
//       transition={{ duration: 0.6 }}
//       className={`relative w-full max-w-4xl mx-auto mt-6
//         rounded-3xl overflow-hidden shadow-2xl
//         ${
//           winner
//             ? "bg-gradient-to-r from-green-500 via-emerald-500 to-green-600"
//             : "bg-gradient-to-r from-gray-600 to-gray-800"
//         }
//       `}
//     >
//       {/* moving shine */}
//       <motion.div
//         className="absolute inset-0 bg-white/20"
//         initial={{ x: "-100%" }}
//         animate={{ x: "200%" }}
//         transition={{ repeat: Infinity, duration: 2.5, ease: "linear" }}
//       />

//       <div className="relative z-10 flex items-center justify-between px-10 py-5 text-white">
//         <div className="flex items-center gap-4">
//           <motion.span
//             animate={{ scale: [1, 1.3, 1] }}
//             transition={{ repeat: Infinity, duration: 1.5 }}
//             className="text-4xl"
//           >
//             🏆
//           </motion.span>

//           <span className="text-3xl font-extrabold tracking-wide">
//             {winner ? text : "MATCH LEVELLED"}
//           </span>
//         </div>

//         <motion.span
//           animate={{ opacity: [1, 0.3, 1] }}
//           transition={{ repeat: Infinity, duration: 1 }}
//           className="bg-black/40 px-4 py-2 rounded-full text-lg font-bold"
//         >
//           LIVE
//         </motion.span>
//       </div>
//     </motion.div>
//   );
// }

// const VSBadge = ({ win }) => (
//   <motion.div
//     initial={{ scale: 0.7, opacity: 0 }}
//     animate={{ scale: 1, opacity: 1 }}
//     transition={{ duration: 0.5 }}
//     className={`flex items-center justify-center
//       w-40 h-40 rounded-full text-5xl font-black
//       ${
//         win === "DRAW"
//           ? "bg-gray-700 text-white"
//           : "bg-gradient-to-br from-yellow-400 via-orange-500 to-red-600 text-white"
//       }
//       shadow-[0_0_60px_rgba(255,165,0,0.6)]`}
//   >
//     VS
//   </motion.div>
// );

// function LiveCommentary({ headline, sub }) {
//   return (
//     <motion.div
//       initial={{ y: -40, opacity: 0 }}
//       animate={{ y: 0, opacity: 1 }}
//       transition={{ duration: 0.6 }}
//       className="mb-10 w-full mx-auto rounded-3xl
//                  bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600
//                  text-white shadow-[0_0_60px_rgba(99,102,241,0.8)]"
//     >
//       <div className="px-12 py-6 text-center">
//         <motion.h2
//           animate={{ scale: [1, 1.04, 1] }}
//           transition={{ repeat: Infinity, duration: 1.5 }}
//           className="text-5xl font-black tracking-wide"
//         >
//           {headline}
//         </motion.h2>

//         <p className="mt-3 text-3xl font-bold text-yellow-300">{sub}</p>

//         <motion.span
//           animate={{ opacity: [1, 0.4, 1] }}
//           transition={{ repeat: Infinity, duration: 1 }}
//           className="inline-block mt-4 bg-black/40 px-6 py-2 rounded-full text-xl font-bold"
//         >
//           🔴 LIVE BATTLE
//         </motion.span>
//       </div>
//     </motion.div>
//   );
// }

// const VSCard = () => (
//   <motion.div
//     animate={{ scale: [1, 1.15, 1] }}
//     transition={{ repeat: Infinity, duration: 1.2 }}
//     className="flex items-center justify-center h-56 rounded-3xl
//                bg-gradient-to-br from-yellow-400 via-orange-500 to-red-600
//                text-white text-7xl font-black
//                shadow-[0_0_80px_rgba(255,165,0,0.9)]"
//   >
//     VS
//   </motion.div>
// );

// function AdvancedFloorCard({
//   floor,
//   value,
//   achievement,
//   isWinner,
//   isLoser,
//   isDraw,
// }) {
//   const target = Number(floor.target);
//   const remaining = Math.max(target - value, 0);

//   const pct = Math.min(100, Math.round((value / target) * 100));
//   const { color, text } = getProgressMeta(pct);

//   /* STRIP (UNCHANGED) */
//   const stripStyle = isWinner
//     ? "bg-green-600"
//     : isLoser
//       ? "bg-red-600"
//       : "bg-gray-700";

//   const stripText = isWinner ? "🏆 WINNER" : isLoser ? "😞 LOSER" : "🤝 DRAW";

//   return (
//     <motion.div
//       animate={{
//         scale: isWinner ? [1, 1.05, 1] : 1,
//         boxShadow: isWinner
//           ? "0 0 50px rgba(34,197,94,0.7)"
//           : "0 0 25px rgba(0,0,0,0.18)",
//       }}
//       transition={{ repeat: isWinner ? Infinity : 0, duration: 1.3 }}
//       className="relative rounded-3xl p-10 border-4 bg-white shadow-2xl"
//       style={{ borderColor: color }}
//     >
//       {/* WIN / LOSE / DRAW STRIP */}
//       <div
//         className={`absolute top-0 left-0 right-0 py-3
//         text-center text-white font-black text-[32px]
//         rounded-t-3xl ${stripStyle}`}
//       >
//         {stripText}
//       </div>

//       {/* IMAGE */}
//       <div className="flex flex-col items-center mt-12">
//         <img
//           src={floor.photo}
//           className="w-72 h-72 rounded-full border-4"
//           style={{ borderColor: color }}
//         />

//         <p className="mt-4 text-[52px] font-black tracking-wide">
//           {floor.name}
//         </p>
//       </div>

//       {/* ORDERS */}
//       <div className="mt-8 text-center">
//         <div className="text-[96px] font-extrabold leading-none">
//           <span style={{ color: color }}>{value}</span>
//           <span className="opacity-40 text-[56px]"> / {target}</span>
//         </div>

//         <p className="mt-4 text-[34px] font-semibold text-gray-700">
//           {remaining > 0
//             ? `${remaining} orders to target`
//             : "Target completed 🎉"}
//         </p>
//       </div>

//       {/* PROGRESS */}
//       <div className="mt-8">
//         <div className="h-6 bg-gray-200 rounded-full overflow-hidden">
//           <motion.div
//             initial={{ width: 0 }}
//             animate={{ width: `${pct}%` }}
//             transition={{ duration: 0.8 }}
//             className="h-full rounded-full"
//             style={{ backgroundColor: color }}
//           />
//         </div>

//         <div className="mt-4 flex justify-between items-center">
//           <p className="text-[36px] font-extrabold" style={{ color }}>
//             {pct}% achieved
//           </p>

//           <p
//             className="text-[40px] font-black tracking-wider"
//             style={{ color }}
//           >
//             {text}
//           </p>
//         </div>
//       </div>
//     </motion.div>
//   );
// }

import React, { useEffect, useState, useMemo, useRef } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import confetti from "canvas-confetti";
import { apiurl } from "../config/config";

// 🔊 Sounds
import crowdSoundFile from "../audio/winner.mp3";
import winSoundFile from "../audio/winner.mp3";

/* ================= CONFIG ================= */

const FLOOR_HEADS = [
  {
    key: "GMIT",
    name: "Rahul Bhushan",
    target: 1300,
    photo: "/managers/rahulbhusan.jpeg",
  },
  {
    key: "ALTF",
    name: "Anand Suman",
    target: 2050,
    photo: "/managers/anandsuman.png",
  },
];

const FLOOR_MANAGERS = {
  GMIT: ["JayVijay5099", "LavitBhati714","Nitin5210"],
  ALTF: ["SanjayRewani1619", "ASHWANI3434", "Himanshu1203", "Abhishek4629"],
};

const MANAGER_META = {
  SanjayRewani1619: {
    name: "Sanjay",
    target: 700,
    photo: "/managers/sanjayrewani.jpeg",
  },
  Abhishek4629: {
    name: "Abhishek",
    target: 700,
    photo: "/managers/abhishek.jpeg",
  },
  Himanshu1203: {
    name: "Himanshu",
    target: 325,
    photo: "/managers/himanshu.png",
  },
  ASHWANI3434: { name: "Ashwani", target: 325, photo: "/managers/ashwani.png" },
  LavitBhati714: { name: "Lavit", target: 400, photo: "/managers/lavit.jpeg" },
  JayVijay5099: { name: "JayVijay", target: 900, photo: "/managers/jay.jpeg" },
};

const SLIDES = [
  { type: "INTRO" },
  { type: "FLOOR" },
  { type: "MANAGER", A: "Abhishek4629", B: "SanjayRewani1619" },
  { type: "MANAGER", A: "Himanshu1203", B: "ASHWANI3434" },
];

const MANAGER_BATTLES = [
  { A: "Abhishek4629", B: "SanjayRewani1619" },
  { A: "Himanshu1203", B: "ASHWANI3434" },
];

const floorWinnerByPercentage = (aValue, aTarget, bValue, bTarget) => {
  const aPct = (aValue / aTarget) * 100;
  const bPct = (bValue / bTarget) * 100;

  if (Math.round(aPct) === Math.round(bPct)) return "DRAW";
  return aPct > bPct ? "A" : "B";
};

/* ================= UTILS ================= */

const winnerOf = (a, b) => (a === b ? "DRAW" : a > b ? "A" : "B");

const getProgressMeta = (p) => {
  if (p >= 100) return { color: "#16a34a", text: "TARGET ACHIEVED" };
  if (p >= 90) return { color: "#22c55e", text: "EXCELLENT" };
  if (p >= 80) return { color: "#4ade80", text: "VERY GOOD" };
  if (p >= 70) return { color: "#a3e635", text: "ON TRACK" };
  if (p >= 60) return { color: "#facc15", text: "NEEDS PUSH" };
  if (p >= 50) return { color: "#fbbf24", text: "NEEDS PUSH" };
  if (p >= 40) return { color: "#fb923c", text: "CRITICAL PUSH" };
  if (p >= 30) return { color: "#f97316", text: "CRITICAL PUSH" };
  if (p >= 20) return { color: "#ef4444", text: "ALERT" };
  return { color: "#dc2626", text: "HIGH ALERT" };
};

const getBattleCommentary = (A, B, aVal, bVal) => {
  if (aVal === bVal)
    return {
      headline: "It's a Perfect Draw 🤝",
      sub: "Anyone can take the lead with 1 order!",
    };
  const leaderId = aVal > bVal ? A : B;
  const trailerId = aVal > bVal ? B : A;
  const diff = Math.abs(aVal - bVal);
  return {
    headline: `${MANAGER_META[leaderId].name} is leading by +${diff} orders`,
    sub: `${MANAGER_META[trailerId].name} needs ${diff + 1} more orders to WIN 🏆`,
  };
};

/* ================= SCALE HOOK ================= */

function useTVScale() {
  const [scale, setScale] = useState(1);
  useEffect(() => {
    const updateScale = () => setScale(window.innerWidth / 1920);
    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);
  return scale;
}



// const managerWinnerByPercentage = (managers) => {
//   const enriched = managers.map((m) => {
//     const target = MANAGER_META[m.id].target;
//     const pct = target > 0 ? (m.value / target) * 100 : 0;
//     return { ...m, pct };
//   });

//   const maxPct = Math.max(...enriched.map((m) => m.pct));

//   const winners = enriched.filter(
//     (m) => Math.round(m.pct) === Math.round(maxPct)
//   );

//   // DRAW if more than one manager has same %
//   if (winners.length > 1) {
//     return enriched.map((m) => ({ ...m, status: "DRAW" }));
//   }

//   return enriched.map((m) => ({
//     ...m,
//     status:
//       Math.round(m.pct) === Math.round(maxPct) ? "WIN" : "LOSE",
//   }));
// };

const managerWinnerByPercentage = (managers) => {
  const enriched = managers.map((m) => {
    const target = MANAGER_META[m.id].target;
    const pct = target > 0 ? (m.value / target) * 100 : 0;
    return { ...m, pct };
  });

  const sorted = [...enriched].sort((a, b) => b.pct - a.pct);

  const leader = sorted[0];
  const runnerUp = sorted[1];

  // tolerance for real draw (0.5%)
  const isDraw =
    runnerUp && Math.abs(leader.pct - runnerUp.pct) < 0.5;

  if (isDraw) {
    return enriched.map((m) => ({ ...m, status: "DRAW" }));
  }

  return enriched.map((m) => ({
    ...m,
    status: m.id === leader.id ? "WIN" : "LOSE",
  }));
};


/* ================= MAIN COMPONENT ================= */

// export default function AdvancedScreen() {
//   const scale = useTVScale();
//   const [managerOrders, setManagerOrders] = useState({});
//   const [slide, setSlide] = useState(0);
//   const [lastWinner, setLastWinner] = useState(null);
//   const crowdAudio = useRef(null);
//   const winAudio = useRef(null);

//   /* ---------- FETCH ORDERS ---------- */
//   useEffect(() => {
//     const fetchData = async () => {
//       const res = await axios.get(`${apiurl}/utils/crm/realTimeOrderData`, {
//         headers: { token: "ad2355a9d54335e27e2c3a3ed5b6e381" },
//         params: { from_date: "2026-01-27", to_date: "2026-01-27" },
//       });
//       const list = res?.data?.data?.result?.data?.managers || [];
//       const map = {};
//       list.forEach((m) => (map[m.o_manager_name] = Number(m.totalOrders || 0)));
//       setManagerOrders(map);
//     };
//     fetchData();
//     const api = setInterval(fetchData, 30000);
//     return () => clearInterval(api);
//   }, []);

//   /* ---------- SLIDE CYCLE ---------- */
//   const current = SLIDES[slide];
//   useEffect(() => {
//     const duration =
//       current.type === "INTRO" ? 5000 :
//       current.type === "FLOOR" ? 15000 :
//       20000; // MANAGER
//     const timer = setTimeout(() => setSlide((s) => (s + 1) % SLIDES.length), duration);
//     return () => clearTimeout(timer);
//   }, [current.type]);

//   /* ---------- FLOOR DATA ---------- */
//   const floorData = useMemo(() => {
//     const sum = (arr) => arr.reduce((a, b) => a + (managerOrders[b] || 0), 0);
//     return { GMIT: sum(FLOOR_MANAGERS.GMIT), ALTF: sum(FLOOR_MANAGERS.ALTF) };
//   }, [managerOrders]);

//   /* ---------- MANAGER BATTLE ---------- */
//   const managerBattle = useMemo(() => {
//     if (current.type !== "MANAGER") return null;
//     if (current.A === current.B) return null;
//     const aVal = managerOrders[current.A] || 0;
//     const bVal = managerOrders[current.B] || 0;
//     return { aVal, bVal, win: winnerOf(aVal, bVal), diff: Math.abs(aVal - bVal) };
//   }, [current, managerOrders]);

//   /* ---------- CONFETTI + SOUND ---------- */
//   useEffect(() => {
//     if (managerBattle?.win && managerBattle.win !== "DRAW") {
//       confetti({ particleCount: 120, spread: 120 });
//       setLastWinner(managerBattle.win);
//       crowdAudio.current?.play();
//       winAudio.current?.play();
//     }
//   }, [managerBattle]);

//   /* ---------- AUDIO UNLOCK ---------- */
//   useEffect(() => {
//     const unlock = () => {
//       crowdAudio.current?.play();
//       winAudio.current?.play();
//       window.removeEventListener("click", unlock);
//       window.removeEventListener("touchstart", unlock);
//     };
//     window.addEventListener("click", unlock);
//     window.addEventListener("touchstart", unlock);
//     return () => {
//       window.removeEventListener("click", unlock);
//       window.removeEventListener("touchstart", unlock);
//     };
//   }, []);

//   return (
//     <div
//       style={{ transform: `scale(${scale})`, transformOrigin: "top left", width: 1920, height: 1080 }}
//       className="bg-gradient-to-br from-slate-50 via-white to-slate-100 overflow-hidden"
//     >
//       <audio ref={crowdAudio} src={crowdSoundFile} preload="auto" />
//       <audio ref={winAudio} src={winSoundFile} preload="auto" />

//       {current.type === "INTRO" && <IntroSlide />}
//       {current.type === "FLOOR" && <FloorSlide floorData={floorData} />}
//       {current.type === "MANAGER" && managerBattle && (
//         <ManagerBattleSlide battle={managerBattle} A={current.A} B={current.B} />
//       )}
//     </div>
//   );
// }

export default function Agent() {
  const scale = useTVScale();
  const [managerOrders, setManagerOrders] = useState({});
  const [slideType, setSlideType] = useState("INTRO");
  const [battleIndex, setBattleIndex] = useState(0);
  const [floorIndex, setFloorIndex] = useState(0);
  const [groupIndex, setGroupIndex] = useState(0);
    const [topAgents, setTopAgents] = useState([]);
    const [prevAgents, setPrevAgents] = useState({});

  /* ---------- FETCH ORDERS ---------- */
  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(`${apiurl}/utils/crm/realTimeOrderData2`, {
        headers: { token: "ad2355a9d54335e27e2c3a3ed5b6e381" },
        params: { from_date: "2026-01-27", to_date: "2026-01-27" },
      });
      const list = res?.data?.data?.result?.data?.managers || [];
      const agents = res?.data?.data?.result?.data?.topAgents || [];
      const map = {};
      list.forEach((m) => (map[m.o_manager_name] = Number(m.totalOrders || 0)));
      setManagerOrders(map);
        setTopAgents(agents);

                const prev = {};
        topAgents.forEach((a) => {
          prev[a.user_name] = a.orderCount;
        });

        setPrevAgents(prev);
    };
    fetchData();
    const api = setInterval(fetchData, 10000);
    return () => clearInterval(api);
  }, []);

  /* ---------- FLOOR DATA ---------- */
  const floorData = useMemo(() => {
    const sum = (arr) => arr.reduce((a, b) => a + (managerOrders[b] || 0), 0);
    return { GMIT: sum(FLOOR_MANAGERS.GMIT), ALTF: sum(FLOOR_MANAGERS.ALTF) };
  }, [managerOrders]);

  /* ---------- MANAGER BATTLES ---------- */
  //   const MANAGER_BATTLES = [
  //     { A: "Abhishek4629", B: "SanjayRewani1619" },
  //     { A: "Himanshu1203", B: "ASHWANI3434" },
  //   ];

  const MANAGER_GROUPS = [
    ["Abhishek4629", "SanjayRewani1619", "JayVijay5099"],
    ["Himanshu1203", "ASHWANI3434", "LavitBhati714"],
  ];

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (slideType === "INTRO") {
//         setSlideType("FLOOR");
//       } else if (slideType === "FLOOR") {
//         setSlideType("MANAGER");
//         setGroupIndex(0);
//       } else if (slideType === "MANAGER") {
//         if (groupIndex + 1 < MANAGER_GROUPS.length) {
//           setGroupIndex((g) => g + 1);
//                   }else if (slideType === "AGENT"){
//         setSlideType("AGENT");
//         setBattleIndex(0);
//         } else {
//           setGroupIndex(0);
//           setSlideType("FLOOR");
//         }
//       }
//     }, 10000);

//     return () => clearTimeout(timer);
//   }, [slideType, groupIndex]);

useEffect(() => {
  const timer = setTimeout(() => {
    if (slideType === "INTRO") {
      setSlideType("FLOOR");
    } 
    else if (slideType === "FLOOR") {
      setSlideType("MANAGER");
      setGroupIndex(0);
    } 
    else if (slideType === "MANAGER") {
      if (groupIndex + 1 < MANAGER_GROUPS.length) {
        setGroupIndex((g) => g + 1);
      } else {
        setGroupIndex(0);
        setSlideType("AGENT"); // 🔥 SHOW AGENTS
      }
    }
    else if (slideType === "AGENT") {
      setSlideType("FLOOR");
    }
  }, 100000);

  return () => clearTimeout(timer);
}, [slideType, groupIndex]);

  const currentGroup =
    slideType === "MANAGER" ? MANAGER_GROUPS[groupIndex] : null;

//   const managerGroupData = useMemo(() => {
//     if (!currentGroup) return [];

//     const values = currentGroup.map((id) => ({
//       id,
//       value: managerOrders[id] || 0,
//     }));

//     const max = Math.max(...values.map((v) => v.value));

//     return values.map((v) => ({
//       ...v,
//       status: v.value === max && max > 0 ? "WIN" : "LOSE",
//     }));
//   }, [currentGroup, managerOrders]);



const managerGroupData = useMemo(() => {
  if (!currentGroup) return [];

  const baseData = currentGroup.map((id) => ({
    id,
    value: managerOrders[id] || 0,
  }));

  return managerWinnerByPercentage(baseData);
}, [currentGroup, managerOrders]);


  //   /* ---------- SLIDE CYCLE ---------- */
  //   useEffect(() => {
  //     let duration = 0;
  //     if (slideType === "INTRO") duration = 5000;
  //     else if (slideType === "FLOOR") duration = 15000;
  //     else duration = 20000; // MANAGER

  //     const timer = setTimeout(() => {
  //       if (slideType === "INTRO") {
  //         setSlideType("FLOOR"); // intro always shows first
  //       } else if (slideType === "FLOOR") {
  //         setSlideType("MANAGER");
  //         setBattleIndex(0); // start first battle
  //       } else if (slideType === "MANAGER") {
  //         if (battleIndex + 1 < MANAGER_BATTLES.length) {
  //           setBattleIndex((b) => b + 1); // next battle
  //         } else {
  //           setBattleIndex(0);
  //           setFloorIndex((f) => (f + 1) % FLOOR_HEADS.length);
  //           setSlideType("FLOOR");
  //         }
  //       }
  //     }, duration);

  //     return () => clearTimeout(timer);
  //   }, [slideType, battleIndex, floorIndex]);

  /* ---------- SLIDE CYCLE : STRICT 10s ---------- */
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (slideType === "INTRO") {
//         setSlideType("FLOOR");
//       } else if (slideType === "FLOOR") {
//         setSlideType("MANAGER");
//         setBattleIndex(0);
//       } else if (slideType === "MANAGER") {
//         if (battleIndex + 1 < MANAGER_BATTLES.length) {
//           setBattleIndex((b) => b + 1);
//         }else if (slideType === "AGENT"){
//         setSlideType("AGENT");
//         setBattleIndex(0);
//         } else {
//           setBattleIndex(0);
//           setSlideType("FLOOR");
//         }
//       }
//     }, 10000); // 🔥 ALWAYS 10 SECONDS

//     return () => clearTimeout(timer);
//   }, [slideType, battleIndex]);

  /* ---------- CURRENT DATA ---------- */
  const currentFloor = FLOOR_HEADS[floorIndex];
  const currentBattle =
    slideType === "MANAGER" ? MANAGER_BATTLES[battleIndex] : null;

  // Compute manager battle data
  const managerBattle = useMemo(() => {
    if (!currentBattle) return null;
    const aVal = managerOrders[currentBattle.A] || 0;
    const bVal = managerOrders[currentBattle.B] || 0;
    const win = winnerOf(aVal, bVal);
    const diff = Math.abs(aVal - bVal);
    return { aVal, bVal, win, diff };
  }, [currentBattle, managerOrders]);

  
  return (
    <div
      style={{
        transform: `scale(${scale})`,
        transformOrigin: "top left",
        width: 1920,
        height: 1080,
      }}
      className="bg-gradient-to-br from-slate-50 via-white to-slate-100 overflow-hidden"
    >
      {/* <audio ref={crowdAudio} src={crowdSoundFile} preload="auto" />
      <audio ref={winAudio} src={winSoundFile} preload="auto" /> */}

      {/* {slideType === "INTRO" && <IntroSlide />} */}
      {slideType === "INTRO" &&   <AgentsSlide agents={topAgents} prev={prevAgents} />}
      {slideType === "FLOOR" && <FloorSlide floorData={floorData} />}
      {/* {slideType === "MANAGER" && managerBattle && (
        <ManagerBattleSlide battle={managerBattle} A={currentBattle.A} B={currentBattle.B} />
      )} */}

      {slideType === "MANAGER" && (
        <ManagerGroupSlide managers={managerGroupData} />
      )}
      {slideType === "AGENT" && (
        <AgentsSlide agents={topAgents} prev={prevAgents} />
      )}
    </div>
  );
}

/* ================= INTRO SLIDE ================= */

function IntroSlide() {
  return (
    <SlideWrapper>
      <motion.div
        className="text-center mb-16"
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <motion.h1
          animate={{ scale: [1, 1.04, 1] }}
          transition={{ repeat: Infinity, duration: 1.6 }}
          className="text-[96px] font-black tracking-tight bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent"
        >
          🚀 Today’s Sales Battle
        </motion.h1>
        <p className="mt-6 text-[40px] font-semibold text-gray-600">
          Live • Competitive • High Energy
        </p>
      </motion.div>

      <div className="grid grid-cols-2 gap-24 mt-10">
        {FLOOR_HEADS.map((f) => (
          <motion.div
            key={f.key}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-white rounded-[36px] p-12 text-center shadow-xl"
          >
            <img
              src={f.photo}
              className="w-64 h-64 mx-auto rounded-full border-4 border-indigo-500"
            />
            <h2 className="text-[52px] font-black mt-6">{f.name}</h2>
            <p className="text-[32px] text-gray-600">
              Target: <b>{f.target}</b>
            </p>
          </motion.div>
        ))}
      </div>
    </SlideWrapper>
  );
}

/* ================= FLOOR SLIDE ================= */

function FloorSlide({ floorData }) {
  //   const win = winnerOf(floorData.GMIT, floorData.ALTF);
  const win = floorWinnerByPercentage(
    floorData.GMIT,
    FLOOR_HEADS[0].target,
    floorData.ALTF,
    FLOOR_HEADS[1].target,
  );

  return (
    <SlideWrapper>
      <h1 className="text-6xl font-black text-center mb-10">
        Live Floor Performance
      </h1>
      <div className="grid grid-cols-2 gap-12">
        {FLOOR_HEADS.map((f, i) => (
          <AdvancedFloorCard
            key={f.key}
            floor={f}
            value={i === 0 ? floorData.GMIT : floorData.ALTF}
            achievement={Math.round(
              ((i === 0 ? floorData.GMIT : floorData.ALTF) / f.target) * 100,
            )}
            isWinner={win === (i === 0 ? "A" : "B")}
            isLoser={win === (i === 0 ? "B" : "A")}
            isDraw={win === "DRAW"}
          />
        ))}
      </div>
    </SlideWrapper>
  );
}

/* ================= MANAGER BATTLE SLIDE ================= */

function ManagerBattleSlide({ battle, A, B }) {
  const { aVal, bVal, win } = battle;
  const commentary = getBattleCommentary(A, B, aVal, bVal);

  return (
    <SlideWrapper>
      <LiveCommentary headline={commentary.headline} sub={commentary.sub} />
      <div className="grid grid-cols-2 gap-5 mt-10">
        <ManagerCard
          id={A}
          value={aVal}
          status={win === "A" ? "WIN" : win === "B" ? "LOSE" : "DRAW"}
        />
        <ManagerCard
          id={B}
          value={bVal}
          status={win === "B" ? "WIN" : win === "A" ? "LOSE" : "DRAW"}
        />
      </div>
    </SlideWrapper>
  );
}

/* ================= SHARED COMPONENTS ================= */

const SlideWrapper = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center px-5 py-5">
    <AnimatePresence mode="wait">
      <motion.div
        key={Math.random()}
        initial={{ opacity: 0, y: 60, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -60, scale: 0.98 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="w-full rounded-[40px] p-12 bg-white shadow-[0_30px_80px_rgba(0,0,0,0.12)] border border-gray-200 text-gray-900"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  </div>
);

const ManagerCard = ({ id, value, status }) => {
  const m = MANAGER_META[id];
  const pct = Math.min(100, Math.round((value / m.target) * 100));
  const { color, text } = getProgressMeta(pct);
  const remaining = Math.max(m.target - value, 0);

  return (
    <motion.div
      animate={status === "WIN" ? { scale: [1, 1.03, 1] } : {}}
      transition={{ repeat: Infinity, duration: 1.4 }}
      className="relative p-8 rounded-3xl border-4 text-center overflow-hidden"
      style={{
        borderColor: color,
        boxShadow:
          status === "WIN"
            ? "0 0 40px rgba(34,197,94,0.6)"
            : "0 0 20px rgba(0,0,0,0.15)",
      }}
    >
      <StatusStrip status={status} />
      <div
        className="mx-auto w-72 h-72 rounded-full p-2 mb-6"
        style={{
          background: `radial-gradient(circle, ${color} 0%, transparent 70%)`,
        }}
      >
        <img
          src={m.photo}
          className="w-full h-full rounded-full border-4 mt-3"
          style={{ borderColor: color }}
        />
      </div>
      <h2 className="text-3xl font-black">{m.name}</h2>
      <div className="text-[96px] font-extrabold leading-none">
        <span style={{ color }}>{value}</span>
        <span className="opacity-40 text-[56px]"> / {m.target}</span>
      </div>
      <p className="mt-4 text-[34px] font-semibold text-gray-700">
        {remaining > 0
          ? `${remaining} orders to target`
          : "Target completed 🎉"}
      </p>
      <div className="h-5 bg-gray-200 rounded-full overflow-hidden mt-4">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 1 }}
          className="h-full rounded-full"
          style={{ backgroundColor: color }}
        />
      </div>
      <div className="mt-4 flex justify-between items-center">
        <p className="text-[36px] font-extrabold" style={{ color }}>
          {pct}% achieved
        </p>
        <p className="text-[40px] font-black tracking-wider" style={{ color }}>
          {text}
        </p>
      </div>
    </motion.div>
  );
};

const StatusStrip = ({ status }) => (
  <div
    className={`absolute top-0 left-0 right-0 py-2 text-white font-bold text-xl rounded-t-3xl ${status === "WIN" ? "bg-green-600" : status === "LOSE" ? "bg-red-600" : "bg-gray-600"}`}
  >
    {status === "WIN"
      ? "🏆 WINNER"
      : status === "LOSE"
        ? "😞 LOSER"
        : "🤝 DRAW"}
  </div>
);

function LiveCommentary({ headline, sub }) {
  return (
    <motion.div
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="mb-10 w-full mx-auto rounded-3xl bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 text-white shadow-[0_0_60px_rgba(99,102,241,0.8)]"
    >
      <div className="px-12 py-6 text-center">
        <motion.h2
          animate={{ scale: [1, 1.04, 1] }}
          transition={{ repeat: Infinity, duration: 1.5 }}
          className="text-5xl font-black tracking-wide"
        >
          {headline}
        </motion.h2>
        <p className="mt-3 text-3xl font-bold text-yellow-300">{sub}</p>
        <motion.span
          animate={{ opacity: [1, 0.4, 1] }}
          transition={{ repeat: Infinity, duration: 1 }}
          className="inline-block mt-4 bg-black/40 px-6 py-2 rounded-full text-xl font-bold"
        >
          🔴 LIVE BATTLE
        </motion.span>
      </div>
    </motion.div>
  );
}

function AdvancedFloorCard({ floor, value, isWinner, isLoser }) {
  const target = floor.target;
  const remaining = Math.max(target - value, 0);
  const pct = Math.min(100, Math.round((value / target) * 100));
  const { color, text } = getProgressMeta(pct);
  const stripStyle = isWinner
    ? "bg-green-600"
    : isLoser
      ? "bg-red-600"
      : "bg-gray-700";
  const stripText = isWinner ? "🏆 WINNER" : isLoser ? "😞 LOSER" : "🤝 DRAW";

  return (
    <motion.div
      animate={{ scale: isWinner ? [1, 1.05, 1] : 1 }}
      transition={{ repeat: isWinner ? Infinity : 0, duration: 1.3 }}
      className="relative rounded-3xl p-10 border-4 bg-white shadow-2xl"
      style={{ borderColor: color }}
    >
      <div
        className={`absolute top-0 left-0 right-0 py-3 text-center text-white font-black text-[32px] rounded-t-3xl ${stripStyle}`}
      >
        {stripText}
      </div>
      <div className="flex flex-col items-center mt-12">
        <img
          src={floor.photo}
          className="w-72 h-72 rounded-full border-4"
          style={{ borderColor: color }}
        />
        <p className="mt-4 text-[52px] font-black tracking-wide">
          {floor.name}
        </p>
      </div>
      <div className="mt-8 text-center">
        <div className="text-[96px] font-extrabold leading-none">
          <span style={{ color }}>{value}</span>
          <span className="opacity-40 text-[56px]"> / {target}</span>
        </div>
        <p className="mt-4 text-[34px] font-semibold text-gray-700">
          {remaining > 0
            ? `${remaining} orders to target`
            : "Target completed 🎉"}
        </p>
      </div>
      <div className="mt-8">
        <div className="h-6 bg-gray-200 rounded-full overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: `${pct}%` }}
            transition={{ duration: 0.8 }}
            className="h-full rounded-full"
            style={{ backgroundColor: color }}
          />
        </div>
        <div className="mt-4 flex justify-between items-center">
          <p className="text-[36px] font-extrabold" style={{ color }}>
            {pct}% achieved
          </p>
          <p
            className="text-[40px] font-black tracking-wider"
            style={{ color }}
          >
            {text}
          </p>
        </div>
      </div>
    </motion.div>
  );
}

function ManagerGroupSlide({ managers }) {
  const leader = managers.find((m) => m.status === "WIN");

  return (
    <SlideWrapper>
      {leader && (
        <LiveCommentary
          headline={`🔥 ${MANAGER_META[leader.id].name} is leading`}
          sub={`Target: ${MANAGER_META[leader.id].target} orders`}
        />
      )}

      <div className="grid grid-cols-3 gap-6 mt-10">
        {managers.map((m) => (
          <ManagerCard key={m.id} id={m.id} value={m.value} status={m.status} />
        ))}
      </div>
    </SlideWrapper>
  );
}

// function AgentsSlide({ agents, prev }) {
//   const top20 = agents.slice(0, 20);
//   const AGENT_TARGET = 25;

//   // 🔥 TOP 3 COLORS
//   const rankStyle = (rank) => {
//     if (rank === 0)
//       return {
//         bg: "from-yellow-300 to-yellow-500",
//         glow: "shadow-[0_0_25px_rgba(253,224,71,0.8)]",
//       };
//     if (rank === 1)
//       return {
//         bg: "from-slate-300 to-slate-400",
//         glow: "shadow-[0_0_20px_rgba(200,200,200,0.7)]",
//       };
//     if (rank === 2)
//       return {
//         bg: "from-orange-300 to-orange-500",
//         glow: "shadow-[0_0_20px_rgba(251,146,60,0.7)]",
//       };

//     return {
//       bg: "from-emerald-500 to-emerald-600",
//       glow: "",
//     };
//   };

//   return (
//     <SlideWrapper>
//       <h1 className="text-[58px] font-black text-center mb-5 tracking-wide text-slate-800">
//         🔴 LIVE TOP 20 AGENTS
//       </h1>

//       {/* ===== GRID ===== */}
//       <div className="grid grid-cols-2 gap-3">
//         {top20.map((a, i) => {
//           const old = prev[a.user_name] || 0;
//           const increased = a.orderCount > old;

//           const pct = Math.min(
//             100,
//             Math.round((a.orderCount / AGENT_TARGET) * 100)
//           );

//           const style = rankStyle(i);

//           return (
//             <motion.div
//               key={a.user_id}
//               layout   // 🔥 rank jump animation
//               transition={{ type: "spring", stiffness: 140, damping: 16 }}
//               initial={{ opacity: 0, y: 8 }}
//               animate={{
//                 opacity: 1,
//                 y: 0,
//                 scale: increased ? [1, 1.04, 1] : 1,
//               }}
//               className={`
//                 flex items-center gap-3
//                 rounded-xl px-3 py-2
//                 border bg-white
//                 border-slate-200
//                 shadow-md
//                 ${style.glow}
//               `}
//             >
//               {/* ===== RANK BADGE ===== */}
//               <div
//                 className={`
//                   w-11 h-11 shrink-0
//                   flex items-center justify-center
//                   rounded-full text-white
//                   text-base font-black
//                   bg-gradient-to-br ${style.bg}
//                 `}
//               >
//                 #{i + 1}
//               </div>

//               {/* ===== NAME ===== */}
//               <div className="w-44">
//                 <p className="text-[21px] font-black truncate text-slate-800">
//                   {a.user_name}
//                 </p>
//               </div>

//               {/* ===== PROGRESS ===== */}
//               <div className="flex-1">
//                 <div className="h-4 bg-slate-200 rounded-full overflow-hidden">
//                   <motion.div
//                     initial={{ width: `${(old / AGENT_TARGET) * 100}%` }}
//                     animate={{ width: `${pct}%` }}
//                     transition={{ duration: 0.6 }}
//                     className="
//                       h-full rounded-full
//                       bg-gradient-to-r
//                       from-emerald-400 to-emerald-600
//                     "
//                   />
//                 </div>

//                 <p className="text-[12px] font-bold text-emerald-700 mt-1">
//                   {pct}% achieved
//                 </p>
//               </div>

//               {/* ===== ORDER SCORE ===== */}
//               <motion.div
//                 animate={
//                   increased
//                     ? {
//                         scale: [1, 1.22, 1],
//                         boxShadow: [
//                           "0 0 0px rgba(16,185,129,0)",
//                           "0 0 20px rgba(16,185,129,0.7)",
//                           "0 0 0px rgba(16,185,129,0)",
//                         ],
//                       }
//                     : {}
//                 }
//                 transition={{ duration: 0.5 }}
//                 className="
//                   min-w-[62px]
//                   text-center
//                   px-2 py-1
//                   rounded-full
//                   bg-emerald-600
//                   text-white
//                   text-xl
//                   font-black
//                 "
//               >
//                 {a.orderCount}
//               </motion.div>

//               {/* ===== LEADER PULSE ===== */}
//               {i === 0 && (
//                 <motion.div
//                   className="absolute inset-0 rounded-xl border-2 border-yellow-400"
//                   animate={{ opacity: [0.4, 1, 0.4] }}
//                   transition={{ repeat: Infinity, duration: 1.5 }}
//                 />
//               )}
//             </motion.div>
//           );
//         })}
//       </div>
//     </SlideWrapper>
//   );
// }

// import { motion } from "framer-motion";

// function AgentsSlide({ agents, prev }) {
//   const top20 = agents.slice(0, 20);
//   const AGENT_TARGET = 25;

//   /* ===== TWO COLOR SYSTEM ===== */
//   // Primary = Deep Blue
//   // Accent = Emerald
//   const COLORS = {
//     primary: "from-slate-900 via-slate-800 to-slate-900",
//     accent: "from-emerald-500 to-emerald-600",
//     ticker: "from-indigo-700 via-indigo-600 to-indigo-700",
//   };

//   /* ===== TOP 3 STYLE ===== */
//   const rankStyle = (rank) => {
//     if (rank === 0) return "ring-2 ring-yellow-400";
//     if (rank === 1) return "ring-2 ring-slate-300";
//     if (rank === 2) return "ring-2 ring-orange-400";
//     return "";
//   };

//   return (
//     <div className="relative w-full h-full overflow-hidden">

//       {/* ================= BACKGROUND WAVES ================= */}
//       <motion.div
//         className={`absolute inset-0 bg-gradient-to-br ${COLORS.primary}`}
//         animate={{ backgroundPosition: ["0% 50%", "100% 50%"] }}
//         transition={{ repeat: Infinity, duration: 12, ease: "linear" }}
//         style={{ backgroundSize: "200% 200%" }}
//       />

//       {/* Animated wave layers */}
//       <motion.div
//         className="absolute bottom-0 left-0 w-[200%] h-40 bg-white/5 blur-2xl"
//         animate={{ x: ["0%", "-50%"] }}
//         transition={{ repeat: Infinity, duration: 18, ease: "linear" }}
//       />

//       {/* ================= LIVE TICKER ================= */}
//       <div
//         className={`absolute top-0 left-0 w-full h-14 bg-gradient-to-r ${COLORS.ticker} text-white flex items-center overflow-hidden`}
//       >
//         <motion.div
//           animate={{ x: ["100%", "-100%"] }}
//           transition={{ repeat: Infinity, duration: 18, ease: "linear" }}
//           className="whitespace-nowrap text-xl font-black tracking-wide"
//         >
//           🔴 LIVE SALES BATTLE • TOP AGENTS PERFORMANCE • REAL TIME RANKING • TARGET TRACKING •
//         </motion.div>
//       </div>

//       {/* ================= CONTENT ================= */}
//       <div className="relative z-10 pt-20 px-6">
//         <h1 className="text-[56px] font-black text-center text-white mb-6">
//           LIVE TOP 20 AGENTS
//         </h1>

//         <div className="grid grid-cols-2 gap-3">
//           {top20.map((a, i) => {
//             const old = prev[a.user_name] || 0;
//             const increased = a.orderCount > old;

//             const pct = Math.min(
//               100,
//               Math.round((a.orderCount / AGENT_TARGET) * 100)
//             );

//             return (
//               <motion.div
//                 key={a.user_id}
//                 layout
//                 transition={{
//                   type: "spring",
//                   stiffness: 140,
//                   damping: 18,
//                 }}
//                 initial={{ opacity: 0, y: 6 }}
//                 animate={{
//                   opacity: 1,
//                   y: 0,
//                   scale: increased ? [1, 1.03, 1] : 1,
//                 }}
//                 className={`
//                   relative
//                   flex items-center gap-3
//                   rounded-xl px-3 py-2
//                   bg-white/95
//                   shadow-lg
//                   border border-white/40
//                   ${rankStyle(i)}
//                 `}
//               >
//                 {/* ===== TOP 3 PARTICLES ===== */}
//                 {i < 3 && (
//                   <motion.div
//                     className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-400 rounded-full"
//                     animate={{ y: [0, -6, 0], opacity: [1, 0.4, 1] }}
//                     transition={{
//                       repeat: Infinity,
//                       duration: 1.2 + i,
//                     }}
//                   />
//                 )}

//                 {/* ===== RANK ===== */}
//                 <div
//                   className={`
//                     w-11 h-11 shrink-0
//                     flex items-center justify-center
//                     rounded-full
//                     text-white font-black text-base
//                     bg-gradient-to-r ${COLORS.accent}
//                   `}
//                 >
//                   #{i + 1}
//                 </div>

//                 {/* ===== NAME ===== */}
//                 <div className="w-44">
//                   <p className="text-[21px] font-black truncate text-slate-800">
//                     {a.user_name}
//                   </p>
//                 </div>

//                 {/* ===== PROGRESS ===== */}
//                 <div className="flex-1">
//                   <div className="h-4 bg-slate-200 rounded-full overflow-hidden">
//                     <motion.div
//                       initial={{
//                         width: `${(old / AGENT_TARGET) * 100}%`,
//                       }}
//                       animate={{ width: `${pct}%` }}
//                       transition={{ duration: 0.6 }}
//                       className={`h-full bg-gradient-to-r ${COLORS.accent}`}
//                     />
//                   </div>
//                   <p className="text-[12px] font-bold text-emerald-700 mt-1">
//                     {pct}% achieved
//                   </p>
//                 </div>

//                 {/* ===== SCORE ===== */}
//                 <motion.div
//                   animate={
//                     increased
//                       ? {
//                           scale: [1, 1.2, 1],
//                           boxShadow: [
//                             "0 0 0px rgba(16,185,129,0)",
//                             "0 0 20px rgba(16,185,129,0.7)",
//                             "0 0 0px rgba(16,185,129,0)",
//                           ],
//                         }
//                       : {}
//                   }
//                   transition={{ duration: 0.5 }}
//                   className="
//                     min-w-[60px]
//                     text-center
//                     px-2 py-1
//                     rounded-full
//                     bg-emerald-600
//                     text-white
//                     text-xl
//                     font-black
//                   "
//                 >
//                   {a.orderCount}
//                 </motion.div>

//                 {/* ===== LEADER SPOTLIGHT ===== */}
//                 {i === 0 && (
//                   <motion.div
//                     className="absolute inset-0 rounded-xl border-2 border-yellow-400"
//                     animate={{ opacity: [0.4, 1, 0.4] }}
//                     transition={{ repeat: Infinity, duration: 1.5 }}
//                   />
//                 )}
//               </motion.div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// }



// import { motion, AnimatePresence } from "framer-motion";
// import confetti from "canvas-confetti";

function AgentsSlide({ agents, prev }) {
  const AGENT_TARGET = 25;

  const top20 = agents.slice(0, 20);
  const leftColumn = top20.slice(0, 10);
  const rightColumn = top20.slice(10, 20);

  const triggerExplosion = (pct) => {
    if (pct >= 100) {
      confetti({
        particleCount: 120,
        spread: 100,
        origin: { y: 0.4 },
      });
    }
  };

  /* ===== TOP 3 COLORS ===== */
  const getRankStyle = (i) => {
    if (i === 0)
      return {
        rankBg: "from-yellow-300 to-yellow-500",
        glow: "shadow-[0_0_25px_rgba(250,204,21,0.9)]",
        cardBg: "bg-gradient-to-r from-yellow-50 to-yellow-100",
      };

    if (i === 1)
      return {
        rankBg: "from-slate-300 to-slate-400",
        glow: "shadow-[0_0_20px_rgba(203,213,225,0.8)]",
        cardBg: "bg-gradient-to-r from-slate-50 to-slate-100",
      };

    if (i === 2)
      return {
        rankBg: "from-orange-300 to-orange-500",
        glow: "shadow-[0_0_20px_rgba(251,146,60,0.8)]",
        cardBg: "bg-gradient-to-r from-orange-50 to-orange-100",
      };

    return {
      rankBg: "from-slate-700 to-slate-900",
      glow: "",
      cardBg: "bg-white",
    };
  };

  const renderCard = (a, i) => {
    const old = prev[a.user_name] || 0;
    const increased = a.orderCount > old;

    const pct = Math.min(
      100,
      Math.round((a.orderCount / AGENT_TARGET) * 100)
    );

    triggerExplosion(pct);

    const isTop1 = i === 0;
    const style = getRankStyle(i);

    return (
      <motion.div
        key={a.user_id}
        layout
        transition={{ type: "spring", stiffness: 140, damping: 18 }}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{
          opacity: 1,
          scale: increased ? [1, 1.05, 1] : 1,
        }}
        className={`
          relative flex items-center gap-4
          rounded-xl px-4 py-3
          border border-slate-200
          ${style.cardBg}
          ${style.glow}
          overflow-hidden
        `}
      >
        {/* ===== TOP 1 PULSE GLOW ===== */}
        {isTop1 && (
          <motion.div
            className="absolute inset-0 rounded-xl border-2 border-yellow-400"
            animate={{
              opacity: [0.4, 1, 0.4],
              scale: [1, 1.01, 1],
            }}
            transition={{ repeat: Infinity, duration: 1.2 }}
          />
        )}

        {/* ===== RANK BADGE ===== */}
        <div
          className={`
            w-14 h-14 shrink-0
            flex items-center justify-center
            rounded-full text-white
            text-lg font-black
            bg-gradient-to-r ${style.rankBg}
          `}
        >
          #{i + 1}
        </div>

        {/* ===== NAME (BIGGER FOR DISTANCE) ===== */}
        <div className="w-52">
          <p className="text-[24px] font-black truncate text-slate-900">
            {a.user_name}
          </p>
        </div>

        {/* ===== PROGRESS BAR ===== */}
        <div className="flex-1">
          <div className="h-5 bg-slate-200 rounded-full overflow-hidden">
            <motion.div
              initial={{ width: `${(old / AGENT_TARGET) * 100}%` }}
              animate={{ width: `${pct}%` }}
              transition={{ duration: 0.6 }}
              className="h-full bg-gradient-to-r from-emerald-400 to-emerald-600"
            />
          </div>

          <p className="text-[14px] font-bold text-emerald-700 mt-1">
            {pct}% achieved
          </p>
        </div>

        {/* ===== SCORE ===== */}
        <motion.div
          animate={
            increased
              ? {
                  scale: [1, 1.2, 1],
                  boxShadow: [
                    "0 0 0px rgba(16,185,129,0)",
                    "0 0 25px rgba(16,185,129,0.8)",
                    "0 0 0px rgba(16,185,129,0)",
                  ],
                }
              : {}
          }
          transition={{ duration: 0.5 }}
          className="
            min-w-[70px]
            text-center px-3 py-1
            rounded-full
            bg-emerald-600 text-white
            text-2xl font-black
          "
        >
          {a.orderCount}
        </motion.div>
      </motion.div>
    );
  };

  return (
    <div className="relative w-full h-full overflow-hidden">

      {/* ===== BACKGROUND ===== */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"
        animate={{ backgroundPosition: ["0% 50%", "100% 50%"] }}
        transition={{ repeat: Infinity, duration: 15, ease: "linear" }}
        style={{ backgroundSize: "200% 200%" }}
      />

      {/* ===== TICKER ===== */}
      <div className="absolute top-0 w-full h-10 bg-gradient-to-r from-indigo-700 via-indigo-600 to-indigo-700 text-white flex items-center overflow-hidden">
        <motion.div
          animate={{ x: ["100%", "-100%"] }}
          transition={{ repeat: Infinity, duration: 16, ease: "linear" }}
          className="whitespace-nowrap text-xl font-black"
        >
          🔴 LIVE SALES • TOP PERFORMERS • REALTIME RANKING •
        </motion.div>
      </div>

      {/* ===== CAMERA ZOOM ===== */}
      <motion.div
        initial={{ scale: 1.05 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1 }}
        className="relative z-10 pt-12 px-6"
      >
        <h1 className="text-[40px] font-black text-center text-white mb-5">
          LIVE TOP AGENTS
        </h1>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-3">
            {leftColumn.map((a, i) => renderCard(a, i))}
          </div>

          <div className="space-y-3">
            {rightColumn.map((a, i) => renderCard(a, i + 10))}
          </div>
        </div>
      </motion.div>
    </div>
  );
}